"use strict";

angular.module("imagetrend.components").directive("hlpFormBuilderSkillsList", [
    function() {
        return {
            restrict: "AE",
            scope: {
                component: "=?"
            },
            controller: [
                "$scope",
                "EXSkill",
                "$sce",
                function ($scope, EXSkill, $sce) {
                    $scope.skillsloading = true;
                    $scope.selectedskills = [];
                    $scope.skills = [];

                    $scope.trust = function (htmlText) {
                        if (htmlText != null) {
                            //removing first pair of <p> tags to keep description on first line of skill
                            htmlText = (htmlText !== null) ? htmlText.replace('<p>', '').replace('</p>', '') : '';
                        }
                        return $sce.trustAsHtml(htmlText);
                    }

                    if ($scope.skills.length == 0) {
                        $scope.skillsloading = true;
                        EXSkill.get().then(function(Skills) {
                            for (var x in Skills) {
                                for (var y in Skills[x].options) {
                                    Skills[x].total_points +=
                                        Skills[x].options[y].points;
                                }

                                if (Skills[x].max_points > 0)
                                    if (Skills[x].max_points < Skills[x].total_points)
                                        Skills[x].total_points = Skills[x].max_points;
                            }
                            $scope.skills = angular.copy(Skills);
                            $scope.setSelectedValues();
                        });
                    }

                    $scope.setSelectedValues = function() {
                        $scope.selectedskills = [];
                        if ($scope.component.skill_question_ids !== null) {
                            $scope.component.skill_question_ids
                                .split(",")
                                .forEach(function (skillid) {
                                    $scope.skills.forEach(function (skill) {
                                        if (skill.id == skillid.trim()) {
                                            $scope.selectedskills.push(skill);
                                        }
                                    });
                                });
                        }
                        $scope.skillsloading = false;
                    };

                    $scope.updateOrder = function() {
                        $scope.component.skill_question_ids = "";
                        $scope.selectedskills.forEach(function(skill) {
                            if ($scope.component.skill_question_ids == "")
                                $scope.component.skill_question_ids = skill.id;
                            else
                                $scope.component.skill_question_ids +=
                                    "," + skill.id;
                        });
                    };

                    $scope.removeSkill = function(id) {
                        $scope.selectedskills.splice(id, 1);
                        $scope.component.skill_question_ids = "";
                        $scope.selectedskills.forEach(function(skill) {
                            if ($scope.component.skill_question_ids == "")
                                $scope.component.skill_question_ids = skill.id;
                            else
                                $scope.component.skill_question_ids +=
                                    "," + skill.id;
                        });
                        $scope.component.updateEditList = true;
                    };

                    $scope.determineClasses = function(isEven) {
                        var classes = "selectedSkill row no-margin";
                        if (isEven) classes += " even";

                        return classes;
                    };

                    $scope.getPassButtonClass = function() {
                        var classes =
                            "btn btn-group ng-pristine ng-untouched ng-valid ng-binding ng-scope ng-empty btn-default";
                        if ($scope.component.skill_default == "1")
                            classes += " pass";
                        return classes;
                    };

                    $scope.getFailButtonClass = function() {
                        var classes =
                            "btn btn-group ng-pristine ng-untouched ng-valid ng-binding ng-scope ng-empty btn-default";
                        if ($scope.component.skill_default == "2")
                            classes += " fail";
                        return classes;
                    };

                    $scope.selectedSkillOptions = function(selectedSkill) {
                        return {
                            containment: "#selectedskill_" + selectedSkill.id,
                            scrollableContainer:
                                "#selectedskill_" + selectedSkill.id,
                            containerPositioning: "relative",
                            accept: function(
                                sourceItemHandleScope,
                                destSortableScope
                            ) {
                                return (
                                    sourceItemHandleScope.itemScope
                                        .sortableScope.$id ===
                                    destSortableScope.$id
                                );
                            },
                            orderChanged: function() {
                                $scope.updateOrder();
                            }
                        };
                    };

                    $scope.$watch("component.updateSelectedList", function(
                        newList,
                        oldList
                    ) {
                        if ($scope.component.updateSelectedList) {
                            $scope.component.updateEditList = false;
                            $scope.component.updateSelectedList = false;
                            $scope.setSelectedValues();
                        }
                        $scope.component.updateSelectedList = false;
                    });
                }
            ],
            replace: true,
            transclude: true,
            templateUrl:
                "templates/form-builder/form-builder-skills-list/form-builder-skills-list.html",
            link: function(scope, elem, attrs, ctrl) {}
        };
    }
]);
